module.exports = __webpack_public_path__ + "img/muranga.4fa7c47d.png";